import ErrorImg from '../assets/full_page_error.svg?react';
import './ErrorView.less';

const ErrorView = () => {
  return (
    <div className={'error-view-container'}>
      <ErrorImg />
      <h3>Something unexpected occurred</h3>
    </div>
  );
};

export { ErrorView };
